import { axiosClient } from "@/shared/api/axios-client";
import type { IndicadorImpuesto } from "@/lib/types";

export interface CrearIndicadorImpuestoInput {
  codigo: string;
  tasaOCuota: number;
  descripcion: string;
}

export interface EditarIndicadorImpuestoInput {
  codigo: string;
  tasaOCuota: number;
  descripcion: string;
}

/**
 * Catálogo corto (V0/V5/V7) · sin paginar, mismo criterio que el backend
 * (P45 · docs/specs/SPEC_Modulo_IndicadoresImpuesto.md). Devuelve TODOS
 * (activos + inactivos) para que el gestor admin muestre el histórico
 * completo, a diferencia de `/api/catalogos/indicadores-impuesto` (solo
 * activos) que consumen los selectores de captura.
 */
export async function listarIndicadoresImpuestoAdmin(): Promise<IndicadorImpuesto[]> {
  const { data } = await axiosClient.get<IndicadorImpuesto[]>(
    "/api/admin/indicadores-impuesto"
  );
  return data;
}

export async function crearIndicadorImpuesto(
  input: CrearIndicadorImpuestoInput
): Promise<IndicadorImpuesto> {
  const { data } = await axiosClient.post<IndicadorImpuesto>(
    "/api/admin/indicadores-impuesto",
    input
  );
  return data;
}

export async function editarIndicadorImpuesto(
  id: string,
  input: EditarIndicadorImpuestoInput
): Promise<IndicadorImpuesto> {
  const { data } = await axiosClient.patch<IndicadorImpuesto>(
    `/api/admin/indicadores-impuesto/${id}`,
    input
  );
  return data;
}

/** Baja lógica / reactivación · NUNCA hard delete (RN-15 · snapshot histórico). */
export async function cambiarEstadoIndicadorImpuesto(
  id: string,
  activo: boolean
): Promise<IndicadorImpuesto> {
  const { data } = await axiosClient.post<IndicadorImpuesto>(
    `/api/admin/indicadores-impuesto/${id}/estado`,
    { activo }
  );
  return data;
}
